export default "__VITE_ASSET__442e9806__"